var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"cabinet",staticStyle:{"text-align":"center"}},[_c('h1',[_vm._v(_vm._s(_vm.title))])]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.name)}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }